import { IConfig } from '@cian/config/shared';

import { useApplicationContext } from '../../containers/ApplicationContext';
import { useSearchStringManifestInfo } from '../../hooks/useSearchStringManifestInfo';

const SEARCH_STRING_FOR_DAILYRENT_TOGGLE = 'BX.SearchStringForDailyrentOffers.Enabled';

/**
 * Фича-тогл раскатки поисковой строки на посуточную.
 *
 * Пока он выключен, эксперимент не должен ни запрашивать манифест микрофронта, ни ветвиться
 * компонентом: рендер `<ExpSearchStringAndFastFilters>` отправляет экспозицию, и в статистику
 * попали бы пользователи, которым фичу и не собирались показывать. Поэтому с выключенным тоглом
 * панель рисует обычные фильтры мимо эксперимента, а не его группу A.
 */
export function checkSearchStringExperimentAvailable(config: IConfig): boolean {
  return Boolean(config.get<boolean>(SEARCH_STRING_FOR_DAILYRENT_TOGGLE));
}

export function useIsSearchStringExperimentAvailable(): boolean {
  const { config } = useApplicationContext();

  return checkSearchStringExperimentAvailable(config);
}

export function useIsSearchStringExperimentActive(): boolean {
  return Boolean(useSearchStringManifestInfo());
}
